import adminRoutes from '../urls/admin'
import coreRoutes from '../urls/core'

export const URLs = {
  ...adminRoutes,
  ...coreRoutes
}
